import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { api } from '../contexts/AuthContext';
import { Bell } from 'lucide-react';
import toast from 'react-hot-toast';

const Notify = () => {
  const { user } = useAuth();
  const [notifyMessage, setNotifyMessage] = useState('Welcome, {{firstName}}!');
  const [notifyRoles, setNotifyRoles] = useState({ parent: true, teacher: false, admin: false });
  const [notifySubjects, setNotifySubjects] = useState({ abacus: false, math: false, english: false, coding: false });
  const [sendingNotify, setSendingNotify] = useState(false);

  const handleSendNotification = async () => {
    try {
      setSendingNotify(true);
      const roles = Object.entries(notifyRoles).filter(([, v]) => v).map(([k]) => k);
      const subjects = Object.entries(notifySubjects).filter(([, v]) => v).map(([k]) => k);
      await api.post('/users/notifications/broadcast-targeted', {
        messageTemplate: notifyMessage,
        roles,
        subjects,
        type: 'system'
      });
      toast.success('Notification sent');
      // Reset form after successful send
      setNotifyMessage('Welcome, {{firstName}}!');
      setNotifyRoles({ parent: true, teacher: false, admin: false });
      setNotifySubjects({ abacus: false, math: false, english: false, coding: false });
    } catch (e) {
      console.error('Send notification error:', e);
      toast.error(e.response?.data?.message || 'Failed to send notification');
    } finally {
      setSendingNotify(false);
    }
  };

  if (user?.role !== 'admin') {
    return (
      <div className="text-center py-12">
        <Bell className="mx-auto h-12 w-12 text-gray-400" />
        <h3 className="mt-2 text-sm font-medium text-gray-900">Access Denied</h3>
        <p className="mt-1 text-sm text-gray-500">
          You don't have permission to view this page.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Notify</h1>
          <p className="text-gray-600">Send notifications to selected roles and subjects</p>
        </div>
      </div>

      {/* Notify Section */}
      <div className="card">
        <div className="card-header">
          <h3 className="text-lg font-medium text-gray-900">Send Notification</h3>
          <p className="text-sm text-gray-500">Send a message to selected roles and subjects.</p>
        </div>
        <div className="card-body space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Message</label>
            <textarea
              className="input w-full"
              rows={3}
              value={notifyMessage}
              onChange={(e) => setNotifyMessage(e.target.value)}
              placeholder="Welcome, {{firstName}}!"
            />
            <p className="text-xs text-gray-500 mt-1">Supports {'{{firstName}}'} and {'{{lastName}}'} placeholders.</p>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Target Roles</label>
            <div className="flex gap-4">
              {['parent','teacher','admin'].map(r => (
                <label key={r} className="inline-flex items-center gap-2">
                  <input type="checkbox" checked={notifyRoles[r]} onChange={(e) => setNotifyRoles(prev => ({ ...prev, [r]: e.target.checked }))} />
                  <span className="text-sm capitalize">{r}</span>
                </label>
              ))}
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Subjects (optional)</label>
            <div className="flex flex-wrap gap-4">
              {['abacus','math','english','coding'].map(s => (
                <label key={s} className="inline-flex items-center gap-2">
                  <input type="checkbox" checked={notifySubjects[s]} onChange={(e) => setNotifySubjects(prev => ({ ...prev, [s]: e.target.checked }))} />
                  <span className="text-sm capitalize">{s}</span>
                </label>
              ))}
            </div>
            <p className="text-xs text-gray-500 mt-1">Filters parents by their children's student tags and teachers by subjects.</p>
          </div>
        </div>
        <div className="card-footer flex justify-end">
          <button onClick={handleSendNotification} disabled={sendingNotify} className="btn btn-primary">
            {sendingNotify ? 'Sending…' : 'Send Notification'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Notify;


